module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    ref: "dof-slider-scale",
    staticClass: " weex-el weex-text",
    class: [
      'dof-slider-scale',
      !_vm.isFirst && !_vm.isLast && 'dof-slider-scale--mid',
      _vm.isFirst && "dof-slider-scale--first",
      _vm.isLast && "dof-slider-scale--last",
      _vm._isColmo && "colmoFont"
    ],
    style: (_vm._processExclusiveStyle(_vm.style, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._t("default", null, {})], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4fd34a59", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fd34a59","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-slider-scale/index.vue
// module id = 619
// module chunks = 0 1